/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';
    /**
     * Factory callback type
     */
    declare type ErrSrcDirectiveFactoryCb = () => ErrSrcDirective;

    /**
     * Custom scope
     */
    export interface IErrSrcScopeDef {
    }

    /**
     * Custom attrs
     */
    export interface IErrSrcAttrs extends ng.IAttributes {
        src: string;
        ngSrc: string;
        errSrc: string;
    }

    export class ErrSrcDirective implements ng.IDirective {
        public static $name: string = "errSrc";

        public link: (scope: ng.IScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public scope: IErrSrcScopeDef = {
            model: '=',
            change: '&',        // save changes method
            source: '&',        // search source method
            destination: '&',   // search destination method
            disconnectDestination: '&',    // disconnect destination
            disconnectSource: '&',    // disconnect sources
        };

        /**
         * Factory for the directive
         */
        public static Factory(): ErrSrcDirectiveFactoryCb {
            let directive: ErrSrcDirectiveFactoryCb = () => {
                return new ErrSrcDirective();
            };
            return directive;
        }

        // Errors before showing error directive
        private static failsBeforeError: number = 3; // tslint:disable-line:member-ordering

        /**
         * Constructor
         */
        constructor() {
            ErrSrcDirective.prototype.link = (scope: ng.IScope, element: JQuery, attrs: IErrSrcAttrs) => {
                let success: boolean = false;
                let fails: number = 0;
                let lastOkImage: string = "images/thumbnail-loading.png";
                const failoverActivated: boolean = element.data('failover');

                element.bind('error', function(): void {
                    if (failoverActivated) {
                        fails++;
                        if (attrs.errSrc && success && fails >= ErrSrcDirective.failsBeforeError) {
                            element.attr('src', attrs.errSrc);
                        } else if (lastOkImage) {
                            element.attr('src', lastOkImage);
                        }
                    } else {
                        if (attrs.errSrc) {
                            element.attr('src', attrs.errSrc);
                        } else if (attrs.src) {
                            element.attr('src', attrs.src);
                        }
                    }

                });

                if (failoverActivated) {
                    element.bind('load', function(): void {
                        // only set last image if it comes from the backend
                        if (element.attr('src').indexOf("http") === 0 ||
                            element.attr('src').indexOf("api") === 0) {
                            fails = 0;
                            success = true;

                            try {
                                let canvas: HTMLCanvasElement = <HTMLCanvasElement>document.createElement('CANVAS');
                                let ctx: CanvasRenderingContext2D = canvas.getContext('2d');
                                let dataURL: string;
                                canvas.height = this.naturalHeight;
                                canvas.width = this.naturalWidth;
                                ctx.drawImage(this, 0, 0);
                                dataURL = canvas.toDataURL("image/png");
                                lastOkImage = dataURL;
                            } catch ( e ) {
                                // local dev enviroments can't export the canvas because backend and frontend are in different domains, 
                                // just use the previous url
                                lastOkImage = element.attr('src');
                            }
                        }
                    });
                }


                scope.$on('$destroy', () => {
                    element.unbind('error');
                    if (failoverActivated) {
                        element.unbind('load');
                    }
                });
            };
        }
    }
}
